import * as React from 'react';

import { Formatters } from '../../../../gen-src/Localize';
import { cellAlignmentClass, cellBarHeight, ColorPaletteName, disabledCellAlignmentClass } from '../../style/CountBarStyles';
import { TypedBodyCellProps } from '../TypedDataGridInterfaces';
import { CountBar } from './CountBar';

interface CountBarCellFormatterProps {
  readonly count: number | null;
  readonly max: number | null;
  readonly colorPaletteName?: ColorPaletteName;
  readonly disabled?: boolean;
}

function CountBarCellFormatter(props: CountBarCellFormatterProps): JSX.Element {
  return (
    <div className={props.disabled ? disabledCellAlignmentClass : cellAlignmentClass}>
      <CountBar
        maxValue={props.max}
        currentValue={props.count}
        height={cellBarHeight}
        label={props.count !== null ? Formatters.formatCount(props.count) : undefined}
        colorPaletteName={props.colorPaletteName ? props.colorPaletteName : 'spaces'}
        shouldAnimateBarWidth={false}
      />
    </div>
  );
}

export function createCountBarCellFormatter<T>(
  getCountFromRowData: (rowData: T) => number | null,
  getMaxFromRowData: (rowData: T) => number | null,
  colorPaletteName?: ColorPaletteName,
  getDisabledFromRowData?: (rowData: T) => boolean,
): React.Factory<TypedBodyCellProps<T>> {
  // eslint-disable-next-line react/display-name
  return (props: TypedBodyCellProps<T>) => (
    <CountBarCellFormatter
      count={getCountFromRowData(props.row.data)}
      max={getMaxFromRowData(props.row.data)}
      colorPaletteName={colorPaletteName}
      disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
    />
  );
}
